import { Table, TableBody, TableCell, TableContainer, TableRow, Typography, Box } from '@mui/material';
import { FC, ReactNode } from 'react';

interface pageResponseProps {
  data: {
    label: string;
    value: ReactNode;
    icon?: ReactNode;
    iconColor?: string;
  }[];
  title: string;
  size?: any;
  width?: string;
}

const TableFormat: FC<pageResponseProps> = ({ data, title, size = 'small', width = '50%' }) => {
  return (
    <Box width="100%">
      {title && (
        <Typography variant="h6" fontWeight={600} mb={1}>
          {title}
        </Typography>
      )}
      <Box
        sx={{
          borderRadius: 0.2,
          overflow: 'hidden',
        }}>
        <TableContainer>
          <Table size={size} sx={{ border: '1px solid #ddd', borderRadius: '4px' }}>
            <TableBody>
              {data?.map((row, i) => (
                <TableRow
                  key={i}
                  sx={{
                    height: 48,
                    backgroundColor: i % 2 === 0 ? '#fafafa' : '#fff',
                  }}>
                  <TableCell sx={{ fontWeight: 600, width: width }}>
                    {row.icon && (
                      <Box
                        component="span"
                        sx={{
                          verticalAlign: 'middle',
                          display: 'inline-flex',
                          alignItems: 'center',
                          color: row.iconColor || 'text.secondary',
                          mr: 1,
                        }}>
                        {row.icon}
                      </Box>
                    )}
                    {row.label}
                  </TableCell>
                  <TableCell>{row.value}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default TableFormat;
